import { render, staticRenderFns } from "./SetupPage.vue?vue&type=template&id=69952b3a&scoped=true&"
import script from "./SetupPage.vue?vue&type=script&lang=js&"
export * from "./SetupPage.vue?vue&type=script&lang=js&"
import style0 from "./SetupPage.vue?vue&type=style&index=0&id=69952b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69952b3a",
  null
  
)

export default component.exports